import { WarningOutlined } from '@ant-design/icons';
import { env } from '@/lib/env';
import { colors } from '@/theme/tokens';

// Renders only when VITE_APP_BANNER is set. Used to flag "this app is talking
// to a non-typical-dev backend" — most commonly local API + prod database.
//
// The styling is intentionally loud: red gradient, top of viewport, full-width.
// You can't miss it, you can't accidentally minimize it, and one glance tells
// you "treat what you see as real."

export function EnvBanner() {
  if (!env.appBanner) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: `linear-gradient(90deg, ${colors.red[600]} 0%, ${colors.red[700]} 100%)`,
        color: '#FFFFFF',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: 0.3,
        padding: '6px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        borderBottom: `1px solid ${colors.red[700]}`,
        // Stripey diagonal hint so it reads as "warning tape" at a glance.
        backgroundImage: `repeating-linear-gradient(
          135deg,
          rgba(255,255,255,0.04) 0,
          rgba(255,255,255,0.04) 12px,
          transparent 12px,
          transparent 24px
        ), linear-gradient(90deg, ${colors.red[600]} 0%, ${colors.red[700]} 100%)`,
        flexShrink: 0,
      }}
    >
      <WarningOutlined />
      <span>{env.appBanner}</span>
    </div>
  );
}
